import * as React from 'react';
import {
  TPAComponentsWrapper,
  createRendererWithUniDriver,
} from '../../test/utils';
import { dialogDriverFactory } from './Dialog.driver';
import { Dialog } from '.';

describe('Dialog', () => {
  const render = createRendererWithUniDriver(dialogDriverFactory);

  it('should render', async () => {
    const { driver } = render(<Dialog />);
    expect(await driver.exists()).toBe(true);
  });

  it('should use mobile design', async () => {
    const { driver } = render(
      TPAComponentsWrapper({ mobile: true })(<Dialog data-hook="dialog" />),
      'dialog',
    );
    expect(await driver.isMobile()).toBe(true);
  });

  it('expect dialog to be open', async () => {
    const { driver } = render(<Dialog isOpen />);
    expect(await driver.isDialogOpen()).toBe(true);
  });

  it('expect dialog to be closed', async () => {
    const { driver } = render(<Dialog isOpen={false} />);
    expect(await driver.isDialogOpen()).toBe(false);
  });

  it('should render children', async () => {
    const { driver } = render(
      <Dialog isOpen>
        <div data-hook="dialog-children">Dialog children</div>
      </Dialog>,
    );
    expect(await driver.childExists('[data-hook="dialog-children"]')).toBe(
      true,
    );
  });

  it('expect onClick to be called after clicking on the close button', async () => {
    const onCloseButtonClick = jest.fn();
    const { driver } = render(<Dialog isOpen onClose={onCloseButtonClick} />);

    await driver.clickOnCloseButton();
    expect(onCloseButtonClick).toHaveBeenCalledTimes(1);
  });

  describe('Manual Focus', () => {
    it('expect dialog to be open', async () => {
      const { driver } = render(<Dialog manualFocus isOpen />);
      expect(await driver.isDialogOpen()).toBe(true);
    });

    it('expect dialog to be closed', async () => {
      const { driver } = render(<Dialog manualFocus isOpen={false} />);
      expect(await driver.isDialogOpen()).toBe(false);
    });
  });

  describe('className', () => {
    it('should add className to wrapper when appendToBody is false', async () => {
      const expectedClass = 'someClass';
      const { driver } = render(
        <Dialog appendToBody={false} className={expectedClass} />,
      );

      expect(await driver.hasClass(expectedClass)).toBe(true);
    });

    it('should not add className to wrapper when appendToBody is true', async () => {
      const expectedClass = 'someClass';
      const { driver } = render(
        <Dialog appendToBody={true} className={expectedClass} />,
      );

      expect(await driver.hasClass(expectedClass)).toBe(false);
    });
  });
});
